import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ApiService } from '../services/api.service';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { NavigationService } from '../services/navigation.service';

export const termsResolver: ResolveFn<boolean> = () => {
  const apiService = inject(ApiService);
  const navigationService = inject(NavigationService)

  return apiService.fetchTermsAndCondition().pipe(
    catchError((error) => {
    navigationService.handleResolverError(error)
      return EMPTY;
    })
  );
};
